// extracted by mini-css-extract-plugin
export default {"container":"PostsPage_container__zsA8L","link":"PostsPage_link__FR16T"};